import styled from 'styled-components';
import { COLORS, FONTS, SIZE } from '@app/src/ui';

export const List = styled.ul`
  border: 1px solid ${COLORS.BLACK_BOLD};
  margin: 0 -15px;
  min-height: 65px;
  border-width: 1px 0;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    margin: 15px auto 0;
    width: 100%;
    border: 0;
  }
`;

export const Wrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  padding: 0 15px;

  @media (min-width ${SIZE.TABLET_LANDSCAPE}) {
    padding: 0;
  }
`;

export const SubTitle = styled.p`
  text-transform: uppercase;
  font-size: 15px;
  font-family: ${FONTS.ROBOTO};
  color: ${COLORS.BLACK_BOLD};
  margin-bottom: 14px;
`;